export const GET_MAP = 'mapReducer/GET_MAP' as const;
export const SET_BLD_INFO = 'mapReducer/SET_BLD_INFO' as const;
export const SET_MODAL = 'mapReducer/SET_MODAL' as const;
export const SET_MARKER_INFO = 'mapReducer/SET_MARKER_INFO' as const;
export const SET_N_MARKER_INFO = 'mapReducer/SET_N_MARKER_INFO' as const;
export const SET_GAP_FILTER = 'mapReducer/SET_GAP_FILTER' as const;

export const getMapOption = (payload: any) => ({
  type: GET_MAP,
  payload,
});

export const setBldInfo = (payload: any) => ({
  type: SET_BLD_INFO,
  payload,
});

export const setModal = (payload: any) => ({
  type: SET_MODAL,
  payload,
});

export const setMarkerInfo = (payload: any) => ({
  type: SET_MARKER_INFO,
  payload,
});

export const setNormalMarkerInfo = (payload: any) => ({
  type: SET_N_MARKER_INFO,
  payload,
});

export const setGapFilter = (payload: any) => ({
  type: SET_GAP_FILTER,
  payload,
});

type StorageActions =
  | ReturnType<typeof getMapOption>
  | ReturnType<typeof setBldInfo>
  | ReturnType<typeof setModal>
  | ReturnType<typeof setMarkerInfo>
  | ReturnType<typeof setNormalMarkerInfo>
  | ReturnType<typeof setGapFilter>;

type TGapFilter = {
  gapcost: number[];
  saleprice: number[];
  type: number[];
  date: number[];
};

export interface NormalMarkerInfo {
  complexId: number;
  bldNm: string;
  complexPlatPlc: string;
  complexNum: number;
  complexUseDay: string;
  gapRangeMin: string;
  gapRangeMax: string;
  imageUrl: string;
  layoutPublicAreaMsMin: string;
  layoutPublicAreaMsMax: string;
}

export type StorageState = {
  map: any;
  bldInfo: any;
  modal: boolean;
  markerInfo?: any;
  normalMarkerInfo: NormalMarkerInfo;
  gapFilter?: TGapFilter;
};

const initialState: StorageState = {
  map: [],
  bldInfo: null,
  modal: false,
  markerInfo: {},
  normalMarkerInfo: {
    complexId: 0,
    bldNm: '',
    complexPlatPlc: '',
    complexNum: 0,
    complexUseDay: '',
    gapRangeMin: '',
    gapRangeMax: '',
    imageUrl: '',
    layoutPublicAreaMsMin: '',
    layoutPublicAreaMsMax: '',
  },
  gapFilter: {
    gapcost: [],
    saleprice: [],
    type: [],
    date: [],
  },
};

export default function mapReducer(
  state: StorageState = initialState,
  action: StorageActions,
): StorageState {
  switch (action.type) {
    case GET_MAP:
      return { ...state, map: [action.payload] };
    case SET_BLD_INFO:
      return { ...state, bldInfo: action.payload };
    case SET_MODAL:
      return { ...state, modal: action.payload };
    case SET_MARKER_INFO:
      return { ...state, markerInfo: action.payload };
    case SET_N_MARKER_INFO:
      return { ...state, normalMarkerInfo: action.payload };
    case SET_GAP_FILTER:
      return { ...state, gapFilter: action.payload };
    default:
      return state;
  }
}
